class FeedConstants {
  maxCommentLength: 500;
}

export const feedConstants = new FeedConstants();
